<template>
  <v-autocomplete
    v-model="classification"
    clearable
    item-text="treeName"
    item-value="id"
    :items="classifications"
    label="Clasificación"
    :loading="loading"
    open-on-clear
    prepend-icon="category"
  />
</template>

<script>
import { mapActions, mapState } from "vuex";

/**
 * A component to select and set the classification in the NER app.
 */
export default {
  computed: {
    ...mapState("ner", {
      classifications: state => state.classifications,
      loading: state => state.loadingClassifications
    }),
    classification: {
      get() {
        return this.$store.state.ner.classification;
      },
      set(classification) {
        this.$store.commit("ner/setClassification", classification);
      }
    }
  },
  created() {
    this.getClassifications();
  },
  methods: {
    ...mapActions("ner", ["getClassifications"])
  }
};
</script>
